module.exports = __webpack_public_path__ + "img/02.76d33acb.jpg";